import { createErrorReporter } from '@sleepstation/error-reporter'
import { isRunningInBrowser } from '@sleepstation/utils'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const ERROR_REPORTER = isRunningInBrowser() ? createErrorReporter() : null

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

// Get our Sentry error reporter
const getErrorReporter = () => ERROR_REPORTER

export default getErrorReporter
